export default "__VITE_ASSET__4d04a5f3__"